<mat-form-field>
  <mat-label>Placeholder</mat-label>
  <input matInput [placeholder]="placeholder" [formControl]="formControl">
</mat-form-field>
